import { render, staticRenderFns } from "./ProjectCuringInfoView.vue?vue&type=template&id=0470e7e9&scoped=true&"
import script from "./ProjectCuringInfoView.vue?vue&type=script&lang=js&"
export * from "./ProjectCuringInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0470e7e9",
  null
  
)

export default component.exports